import axios from 'axios';
import store from '@/store/Store';

const API_URL = import.meta.env.VITE_API_URL;

export const fetchHasUnread = async () => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/tiedotteet/unread`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchNotifications = async () => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/tiedotteet/`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const postNotificationsRead = async () => {
  const token = store.getState().auth.token;
  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(`${API_URL}/tiedotteet/read`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
